//
// Entry pane criteria widgets like
// filter, sorter and paginator trigger
// an ajax load rather than a full page load
//

import { component as defineComponent } from 'flightjs';

var entryPaneCriteria = function() {
    this.attributes({
        aSelector: 'a',
    });

    this.after('initialize', function() {
        this.on(this.select('aSelector'), 'click', function(e) {
            if (this.isEnabled()) {
                if ($(e.currentTarget).is('[data-disabled]')) {
                    return;
                }

                // 0 is a left click - allows middle click to open new tab
                if (e.button > 0) {
                    return;
                }

                this.trigger('uiEntryPaneCriteriaChanged', {
                    url: e.currentTarget.href,
                    noscroll: e.currentTarget.hasAttribute('data-entry-pane-anchors-noscroll'),
                });

                e.preventDefault();
            }
        });
    });

    // IE9 doesn't support pushstate. Instead of breaking IE9 users back button,
    // fallback to a full page load
    this.isEnabled = function() {
        return !!window.history.pushState;
    };
};

export default defineComponent(entryPaneCriteria);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/entry-pane-anchors.js